import Backbone from 'backbone';

export default class GcnView extends Backbone.View {
  destroy(): void {
    this.stopListening();
  }
}
